import { Article } from "@/domain/content/article";
import { ArticleCategory } from "@/domain/content/articleCategory";
import { SearchArticlesResult } from "@/domain/content/searchArticlesResult";
import { JobListingCategoryContent } from "@/domain/content/jobListingCategoryContent";

import { httpClient } from "./http-client";
const basePath = "/content";

export const contentAPI = {
  getArticle: async (slug: string) => 
  {
    const url = basePath + "/article?slug=" + slug;
    const response = await httpClient.get(url);
    return response.data as Article;
  },
  searchArticles: async (categoryName: string[], resourceType: string) => 
  {
    var categoryNameQuery = ''; 
    if(Array.isArray(categoryName))
    {
      categoryName.forEach(element => {
        if (element != '')
        {
          categoryNameQuery = categoryNameQuery + "&category=" + encodeURIComponent(element);
        }
      });
    } 
    else
    {
      categoryNameQuery = "&category=" + encodeURIComponent(categoryName);
    }

    var resourceTypeQuery = resourceType != null ? "&resourceType=" + resourceType : '';

    const url = basePath + "/search/?" + categoryNameQuery + resourceTypeQuery;
    const response = await httpClient.get(url);
    return response.data as SearchArticlesResult;
  },
  getCategories: async (resourceType: string) => 
  {
    var resourceTypeQuery = resourceType != null ? "?resourceType=" + resourceType : '';
    const url = basePath + "/categories" + resourceTypeQuery;
    const response = await httpClient.get(url);
    return response.data as ArticleCategory[];
  }, 
  getJobListingCategoryContent: async (categoryName: string) => 
    {
      const url = basePath + "/joblistingcategory?categoryName=" + categoryName;
      const response = await httpClient.get(url);
      return response.data as JobListingCategoryContent;
    }
};